export class VideoData {
  id: number;
  schemeCode: string;
  schemeName: string;
  videoName: string;
  videoUrl: string;
}
